import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../../../common';
import { DpsCommonModule } from '../../dataprotection-common/dataprotection-common.module';
import { ReplicatedVdc } from './replicated-vdc.component';
import { ReplicatedVapp } from './replicated-vapp.component';
import { ReplicatedOutOfPlaceRestore } from './out-of-place-restore.component';
import { ReplicatedVdcManage } from './replicated-vdc-manage.component';
import { ReplicatedRestorePoints } from './restore-points.component'
import { ReplicatedVappVm } from './replicated-vapp-vm.component'
import { ReplicatedRestorePointsVm } from './restore-points-vm.component'

@NgModule({
    declarations: [
        ReplicatedVdc,
        ReplicatedVapp,
        ReplicatedOutOfPlaceRestore,
        ReplicatedVdcManage,
        ReplicatedRestorePoints,
        ReplicatedVappVm,
        ReplicatedRestorePointsVm
    ],
    imports: [
        BrowserModule,
        FormsModule,
        VcaCommonModule,
        DpsCommonModule,
        TranslateModule,
        ClarityModule.forRoot()
    ],
    providers: [
    ],
    exports: [
        RouterModule,
        ReplicatedVdc,
        ReplicatedVapp,
        ReplicatedOutOfPlaceRestore,
        ReplicatedVdcManage,
        ReplicatedRestorePoints,
        ReplicatedVappVm,
        ReplicatedRestorePointsVm
    ]

})
export class ReplicatedVdcModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/replicated-vdc/replicated-vdc.module.ts